// components/PhoneInput.js
import React from 'react';
import TextField from '@mui/material/TextField';

const PhoneInput = ({ label = "Customer Phone", value, onChange, required = false, ...props }) => {
  const handleInputChange = (e) => {
    const input = e.target.value;
    if (/^\d{0,10}$/.test(input)) {
      onChange(input);
    }
  };

  return (
    <TextField
      fullWidth
      label={label}
      value={value}
      onChange={handleInputChange}
      inputProps={{
        maxLength: 10,
        inputMode: 'numeric',
        pattern: '[0-9]*'
      }}
      required={required}
      {...props}
    />
  );
};

export default PhoneInput;
